import React from 'react';
import Relay from 'react-relay';
import RelayStore from '../../RelayStore';

import SportPanel from '../../components/SportPanel';
import UpdateSportMutation from '../../mutations/Sport/UpdateSportMutation';

class EditSport extends React.Component {
  onUpdateSport(sport){

  	const { lang, langList } = this.props.location.state;
		const { viewer, relay } = this.props ;

		sport.levels.forEach(level => {
			langList.forEach(langInList => {
				if (typeof level[langInList] == 'undefined' || level[langInList] == "")
					level[langInList] = level[lang];
			});
		});
		sport.positions.forEach(position => {
			langList.forEach(langInList => {
				if (typeof position[langInList] == 'undefined' || position[langInList] == "")
					position[langInList] = position[lang];
			});
		});
		sport.certificates.forEach(certificate => {
			langList.forEach(langInList => {
				if (typeof certificate.name[langInList] == 'undefined' || certificate.name[langInList] == "" || certificate.name[langInList] == null)
					certificate.name[langInList] = certificate.name[lang];
			});
		});
		langList.forEach(langInList => {
			if (typeof sport.name[langInList] == 'undefined' || sport.name[langInList] == "")
				sport.name[langInList] = sport.name[lang];
		});

  	let mutation = new UpdateSportMutation({sport, viewer});

  	relay.commitUpdate( mutation, {
		onFailure: (error) => {
			console.log('error', error.getError());
			alert('Update Failed');
		},
		onSuccess: (response) => {
			console.log('success', response);
			alert('Update Success');
		}
  	});
  }


  render() {
	const { lang, sportStatusList, langList } = this.props.location.state;
	const { sport } = this.props.viewer ;

    return (
		<div className="panel" style={{marginTop:20}}>
		    <SportPanel
		      sport={sport}
		      lang={lang}
		      sportStatusList={sportStatusList}
		      langList={langList}
		      onUpdateSport={this.onUpdateSport.bind(this)}
		      text="Update"/>
		</div>
    );
  }

}

export default Relay.createContainer(EditSport, {

	initialVariables: {
		sportId: null,
	},

  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
				supportedLanguages,
        sport (id: $sportId) {
					id,
					name {
						FR,
						EN,
						DE,
						ES
					},
					positions {
						FR,
						EN,
						DE,
						ES
					},
					logo,
					certificates {
						name {
							FR,
							EN,
							DE,
							ES
						}
					},
					levels {
						FR {
							name,
							description,
							skillLevel
						},
						EN {
							name,
							description,
							skillLevel
						},
						DE {
							name,
							description,
							skillLevel
						},
						ES {
							name,
							description,
							skillLevel
						},
					}
					status,
				}
        ${UpdateSportMutation.getFragment('viewer')}
			}
		`
	}
});



// WEBPACK FOOTER //
// ./src/pages/Sport/EditSport.js